import { httpGet, httpPost } from './api/axios_api';
import Constants from '../constants/constants';
import actions from './player_actions';

export async function getPlayerByHomeUser() {
  const url = `${Constants.BACKEND_URL}/get-player-by-home-user`;
  return httpGet(url, {});
}

export async function getPersonnelPlayers(personnelID) {
  const url = `${Constants.BACKEND_URL}/get-personnel-players/` + personnelID;
  return httpGet(url, {});
}

export async function getPlayerByInsightsId(insightsId) {
  const url = `${Constants.BACKEND_URL}/players/get-player-by-insights-id`;
  return httpPost(url, {
    insights_id: insightsId,
  });
}

export async function getOnePlayer(playerID) {
  const url = `${Constants.BACKEND_URL}/get-one-player/` + playerID;
  return httpGet(url, {});
}

export async function getPlayerTeamMembers(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-team-members/` + playerID;
  return httpGet(url, {});
}

export async function sharePlayer(playerID, teamMemberID) {
  const config = {
    params: {
      team_member_id: teamMemberID,
      player_id: playerID,
    },
  };
  const url = `${Constants.BACKEND_URL}/share-player`;
  return httpPost(url, config);
}

export async function searchOutOfGymPlayers(query, page) {
  const url = `${Constants.BACKEND_URL}/search-out-of-gym-players/${query}/${page}`;
  return httpGet(url, {});
}

export async function cancelPlayerShare(playerID, teamMemberID) {
  const config = {
    params: {
      team_member_id: teamMemberID,
      player_id: playerID,
    },
  };
  const url = `${Constants.BACKEND_URL}/cancel-player-share`;
  return httpPost(url, config);
}

export async function unarchivePlayer(playerID) {
  const config = {
    params: {
      player_id: playerID,
    },
  };
  const url = `${Constants.BACKEND_URL}/unarchive-player`;
  return httpPost(url, config);
}

export async function archivePlayer(playerID, fullArchive) {
  const config = {
    params: {
      player_id: playerID,
      full_archive: fullArchive,
    },
  };
  const url = `${Constants.BACKEND_URL}/archive-player`;
  return httpPost(url, config);
}

export async function getArchivedPlayers() {
  const url = `${Constants.BACKEND_URL}/get-archived-players`;
  return httpGet(url, {});
}

export async function getAssignedArchivedPlayers() {
  const url = `${Constants.BACKEND_URL}/get-assigned-archived-players`;
  return httpGet(url, {});
}

export function getAssignedPlayers() {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/assigned-players`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.assignedPlayers,
          assigned_players: response.data.assigned_players,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}

export function getSpecificPlayer(playerID) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/get-player/` + playerID;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.getSpecificPlayer,
          specific_player: response.data.player,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}
export function getMyPlayers() {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/get-my-players`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.getMyPlayers,
          players_data: response.data.players_data,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}
